import React from "react";
import Container from "react-bootstrap/Container";
import DynamicLogo from "../../common/DynamicLogo";
import { useNavigate } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { storage } from "../../utils/auth";

function SubAdminNavbar() {
  const navigate = useNavigate();

  const handleLogout = () => {
    storage.clearNamespace("adminvip");
    navigate("/adminvip/login");
  };
  return (
    <>
      <Navbar
        bg="dark"
        expand="lg"
        data-bs-theme="dark"
        className="bg-body-tertiary"
      >
        <div className="d-flex">
          {" "}
          <DynamicLogo
            
            alt="logo-img"
            className="my-1 mx-5"
            style={{ height: "80px", width: "auto", maxWidth: "250px", cursor: "pointer" }}
            onClick={() => navigate("/adminvip/exhibitor-list")}
          />
        </div>
        <Container>
          <Navbar.Toggle aria-controls="navbarScroll" />
          <Navbar.Collapse id="navbarScroll">
            <Nav
              className="me-auto my-2 my-lg-0"
              // style={{ maxHeight: "100px" }}
              navbarScroll
            >
              {" "}
              <Nav.Link onClick={() => navigate("/adminvip/exhibitor-list")}>
                Invited Buyer List
              </Nav.Link>

              <Nav.Link
                onClick={() => navigate("/adminvip/flight-details")}
              >
                Flight Service
              </Nav.Link>
              <Nav.Link onClick={() => handleLogout()}>Logout</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default SubAdminNavbar;
